import { memo, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { Images } from "@coworker/apprestructured/src/task-management/components/Images/Images";
import Actions from "./Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";

function ImagesDemo() {
  const [disabled, setDisabled] = useState(false);

  const imageUrls: string[] = [
    "https://www.ikea.com/ext/ingkadam/m/5a37ddae9d8d54b/original/PH196335.JPG?f=s",
    "https://www.ikea.com/se/en/images/products/hoevolm-rack-with-6-knobs-oak__1042233_pe841304_s5.jpg?f=s",
    "https://www.thenordroom.com/wp-content/uploads/2024/01/colorful-ikea-living-room-home-style-trends-guide-nordroom.jpg",
    "https://dropinblog.net/34241141/files/featured/Ikea_Cover.png",
    "https://www.ikea.com/ext/ingkadam/m/5f9413ef28559f5d/original/PH205227.jpg?f=s",
  ];

  return (
    <Demo>
      <Name>Images</Name>
      <Highlight>
        <FixaListView id="addimagesdemo" size="small">
          <Images imageUrls={imageUrls} disabled={disabled} />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="imagesdemo-disabled"
          id="imagesdemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(ImagesDemo);
